export default __webpack_public_path__ + "static/media/1.487de4cf.svg";